export default __webpack_public_path__ + "static/media/undraw_transfer_money_rywa.96df2da7.svg";